import {
  CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET,
  CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET,
  CHANGE_ORDER_QUOTES_SELECT,
  CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE,
} from 'components/admin/work-orders/details/change-order-quotes/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { changeOrderTasksApi } from 'services/api/change-order-tasks-api';
import { updateChangeOrderTask } from 'components/admin/work-orders/details/change-order-tasks/store/actions';
import {
  loadWorkOrderRequest,
  selectNavigationBar,
  detailsMovedToAcr,
} from 'actions/admin/work-orders/details/details';

export function setShowChangeOrderQuoteModal() {
  return {
    type: CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET,
  };
}

export function setShowChangeOrderQuoteRequestConfirmation() {
  return {
    type: CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET,
  };
}

export function requestChangeOrderQuote(changeOrderTaskId, values) {
  return (dispatch) => {
    return changeOrderTasksApi
      .requestChangeOrderQuote(changeOrderTaskId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowChangeOrderQuoteModal());
          dispatch(setShowChangeOrderQuoteRequestConfirmation());
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function submitChangeOrderQuote(changeOrderTaskId, values) {
  return (dispatch) => {
    return changeOrderTasksApi
      .submitChangeOrderQuote(changeOrderTaskId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowChangeOrderQuoteModal());
          dispatch(setShowChangeOrderQuoteRequestConfirmation());
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function withdrawChangeOrderQuote(changeOrderTaskId) {
  return (dispatch) => {
    return changeOrderTasksApi
      .withdrawChangeOrderQuote(changeOrderTaskId)
      .then((response) => {
        if (response.ok) {
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function withdrawChangeOrderQuoteRequest(changeOrderTaskId) {
  return (dispatch) => {
    return changeOrderTasksApi
      .withdrawChangeOrderQuoteRequest(changeOrderTaskId)
      .then((response) => {
        if (response.ok) {
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateChangeOrderQuote(changeOrderTaskId, values) {
  return (dispatch) => {
    return changeOrderTasksApi
      .updateChangeOrderQuote(changeOrderTaskId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function selectChangeOrderQuote(changeOrderTaskId) {
  return {
    type: CHANGE_ORDER_QUOTES_SELECT,
    payload: changeOrderTaskId,
  };
}

export function closeChangeOrderQuoteDetailsModal() {
  return {
    type: CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE,
  };
}

export function moveToAcr(workOrderId, changeOrderTaskIds) {
  return (dispatch) => {
    return changeOrderTasksApi
      .moveToAcr(workOrderId, changeOrderTaskIds)
      .then((response) => {
        if (response.ok) {
          response.changeOrderTasks.forEach((cot) =>
            dispatch(updateChangeOrderTask(cot))
          );
          dispatch(loadWorkOrderRequest(workOrderId, true, false));
          dispatch(selectNavigationBar(workOrderId, 1));
          dispatch(detailsMovedToAcr());
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/store/actions.js